<template>
  <div class="widget border-0">
    <div class="header">
      <div class="title">
        {{ __('Conversão de negócios para negócios fechados') }}
      </div>
    </div>
    <div
      class="body mt-4"
      v-if="loading"
    >
      <span class="loading"><i class="fa fa-circle-o-notch fa-spin" /></span>
    </div>
    <div
      class="body mt-4"
      v-else
    >
      <div v-if="show">
        <ChartRoundedHorizontalBarChart
          class="chart"
          :id="id"
          :background="background"
          :chart-data="chartData"
          :options="options"
          datalabels="datalabels"
        />
      </div>
      <div
        class="empty"
        v-else
      >
        <h2>{{ __('Nenhum dado foi encontrado neste período!') }}</h2>
        <h3>{{ __('Já tentou alterar as datas?') }}</h3>
      </div>
    </div>
  </div>
</template>

<script>
import progresWidget from '../../mixins/progress-widget';
import chartDealConversion from '../../mixins/chartDealConversion';

export default {
  mixins: [
    progresWidget,
    chartDealConversion,
  ],

  props: ['name', 'id'],

  data: () => ({
    background: ['#FF7F00', '#2CEBA9', '#FF2E56'],
  }),
};
</script>
